import { useVistaFeatureFlag } from '@99designs/experiments';

export function useChatBriefFeatureFlag(esMpvId: string, workId?: string | null) {
    return useVistaFeatureFlag('design_services_chat_brief', [
        {
            value: esMpvId.toLowerCase(),
            oneOf: ['businesscarddesign', 'flyerdesign', 'bannerdesign'],
        },
        // Exclude workId pathways so they are never enrolled in the experiment.
        { value: Boolean(workId), must: false },
    ]);
}
